import { TopDiscountsTodayBaseProps, calculateDiscount, formatDiscount, formatPrice } from './TopDiscountsTodayBase'
import { TagBadgeMobile } from '@/components/ui/badge'
import { useHorizontalScroll } from '@/hooks/useHorizontalScroll'
import { InfoTooltip } from '@/components/ui/info-tooltip'

export const TopDiscountsTodayMobile = ({ items, loading = false, onItemClick, onBuyClick }: TopDiscountsTodayBaseProps) => {
  const { scrollContainerRef, isDragging, handlers, style } = useHorizontalScroll()

  // Show loading state
  if (loading) {
    return (
      <div className="h-full px-6 pt-6 pb-6">
        <div className="flex items-center">
          <h3 className="font-plus-jakarta font-medium text-[16px] leading-[24px] text-[#2d2923] dark:text-[#fdfdfd] uppercase">
            <span className="inline-flex items-center gap-2">
              Top Discounts Today
              <InfoTooltip content="Assets currently priced at the largest discount vs their most recent reported funding-round valuation." ariaLabel="Top Discounts Today info" />
            </span>
          </h3>
        </div>
        <div className="pt-5">
          <p className="text-sm text-muted-foreground">Loading discounts...</p>
        </div>
      </div>
    )
  }

  // Show empty state
  if (items.length === 0) {
    return (
      <div className="h-full px-6 pt-6 pb-6">
        <div className="flex items-center">
          <h3 className="font-plus-jakarta font-medium text-[16px] leading-[24px] text-[#2d2923] dark:text-[#fdfdfd] uppercase">
            <span className="inline-flex items-center gap-2">
              Top Discounts Today
              <InfoTooltip content="Assets currently priced at the largest discount vs their most recent reported funding-round valuation." ariaLabel="Top Discounts Today info" />
            </span>
          </h3>
        </div>
        <div className="pt-5">
          <p className="text-sm text-muted-foreground">No discounted assets available</p>
        </div>
      </div>
    )
  }

  return (
    <div className="relative h-full flex flex-col overflow-hidden px-6 pt-6 pb-6">
      {/* Header */}
      <div className="flex items-center">
        <h3 className="font-plus-jakarta font-medium text-[16px] leading-[24px] text-[#2d2923] dark:text-[#fdfdfd] uppercase">
          <span className="inline-flex items-center gap-2">
            Top Discounts Today
            <InfoTooltip content="Assets currently priced at the largest discount vs their most recent reported funding-round valuation." ariaLabel="Top Discounts Today info" />
          </span>
        </h3>
      </div>

      {/* Cards container - horizontal scroll */}
      <div 
        ref={scrollContainerRef}
        className="flex overflow-x-auto scrollbar-hide mt-5 gap-2"
        style={style}
        {...handlers}
      >
        {items.map((item) => {
          const discount = calculateDiscount(item)
          
          return (
            <div
              key={item.order_id}
              className="flex-shrink-0 w-[196px] flex flex-col cursor-pointer"
              onClick={() => {
                if (!isDragging) {
                  onItemClick?.(item)
                }
              }}
            >
              <div className="bg-white dark:bg-[#1c1c1c] flex flex-col gap-[18px] p-[14px]">
                <div className="flex items-start justify-between gap-2 w-full">
                  <h4 className="font-plus-jakarta font-semibold text-[16px] leading-[24px] text-[#2d2923] dark:text-[#fdfdfd] truncate">
                    {item.project_name}
                  </h4>
                  <TagBadgeMobile tag={item.tag} />
                </div>

                <div className="flex flex-col gap-[6px]">
                  <p className="font-plus-jakarta font-medium text-[#2d2923] dark:text-[#fdfdfd] leading-[36px] tracking-[-0.2px]">
                    <span className="text-[26px]">-{formatDiscount(discount)} </span>
                    <span className="text-[16.77px] text-[rgba(45,41,35,0.48)] dark:text-[rgba(253,253,253,0.48)]">%</span>
                  </p>
                  <p className="font-plus-jakarta font-medium text-[13px] leading-[18px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)]">
                    {formatPrice(item)}
                  </p>
                </div>

                <div className="flex flex-col gap-[6px] w-full">
                  <button
                    className="w-full bg-white dark:bg-transparent border border-[rgba(45,41,35,0.12)] dark:border-[rgba(253,253,253,0.12)] flex items-center justify-center px-4 py-2 font-plus-jakarta font-medium text-[12px] leading-[16px] text-[#2d2923] dark:text-[#fdfdfd]"
                    onClick={(e) => {
                      e.stopPropagation()
                      onItemClick?.(item)
                    }}
                  >
                    More details
                  </button>
                  <button
                    className="w-full bg-[#2d2923] dark:bg-[#fdfdfd] flex items-center justify-center px-4 py-2 font-plus-jakarta font-medium text-[12px] leading-[16px] text-white dark:text-[#2d2923]"
                    onClick={(e) => {
                      e.stopPropagation()
                      onBuyClick?.(item)
                    }}
                  >
                    BUY
                  </button>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
